import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaUserCircle } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { IoDocument } from "react-icons/io5";
import styles from "./Navbar.module.css";
import MobileNavOptions from "../MobileNavOptions";
import AuthContext from "../../store/AuthContext";
import { FaArrowRightLong } from "react-icons/fa6";
import { toast } from 'react-toastify';

const Navbar = ({ type, className = "" }) => {
    const [isVisibleMobile, setIsVisibleMobile] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // 2. useLocation hook use kiya
    const location = useLocation();
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const authCtx = useContext(AuthContext);
    const isHome = type === "home";

    // 3. Current page business page hai ya nahi check kiya
    const isBusinessPage = location.pathname.startsWith("/solutions-for-businesses");

    const navOptionClass = isHome
        ? styles.eachNavOptionWhite
        : styles.eachNavOptionBlack;

    const mobileNavVisibleHandler = (s) => setIsVisibleMobile(s);

    // === DYNAMIC BUTTON LOGIC ===
    const buttonText = isBusinessPage ? "For Staff" : "For Salons";
    const buttonLink = isBusinessPage ? "/" : "/solutions-for-businesses";

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
        document.body.classList.toggle("no-scroll", isVisibleMobile);
    }, [isVisibleMobile]);

    // Scroll detection
    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 40);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Handle mobile hardware back button to close menu
    useEffect(() => {
        if (!isVisibleMobile) return;

        window.history.pushState({ mobileMenuOpen: true }, "");

        const handlePopState = (event) => {
            mobileNavVisibleHandler(false);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
            if (window.history.state?.mobileMenuOpen) {
                window.history.back();
            }
        };
    }, [isVisibleMobile]);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <>
            <header
                className={`${styles.mainHeaderWrapper} ${className} ${isScrolled ? styles.scrolled : ""
                    }`}
            >
                {/* Left: Logo */}
                <div className={styles.leftHeaderWrapper}>
                    <a href="/">
                        <img
                            src="https://d26wg3m90fktzo.cloudfront.net/uploads/001721807041000002/1761386600402-logo-stylelink-small-pink.png"
                            className={styles.logo}
                            alt="stylelink logo"
                        />
                    </a>
                </div>


                {/* Center: Nav Links */}
                <nav className={styles.centerHeaderWrapper}>
                    <div className={styles.navOptionsContainer}>
                        <Link to="/get-my-salon-resume" className={navOptionClass}>
                            <IoDocument /> Get Resume
                        </Link>
                        <Link to="/salon-jobs-near-me" className={navOptionClass}>
                            <MdWork /> Find Jobs
                        </Link>
                    </div>
                </nav>

                {/* Right: Buttons & Menu */}
                <div className={styles.rightHeaderWrapper}>
                    <div className={styles.navOptionsContainerLink}>

                        {authCtx?.isLoggedIn === false ? (
                            // 4. Desktop Button: Dynamic Link/Text use kiya
                            <>
                                {!isBusinessPage && (
                                    <Link to='/login' className={styles.loginButton}>
                                        <span className={styles.text}>Login</span>
                                    </Link>
                                )}

                                <Link to={buttonLink} className={styles.animatedButton}>
                                    <FaArrowRightLong className={styles.arr2} />
                                    <span className={styles.text}>{buttonText}</span>
                                    <span className={styles.circle}></span>
                                    <FaArrowRightLong className={styles.arr1} />
                                </Link>
                            </>
                        ) : (
                            <div className={styles.profileContainer} ref={dropdownRef}>
                                {authCtx.profilePic ? (
                                    <img
                                        src={authCtx.profilePic}
                                        alt="Profile"
                                        className={styles.profileImage}
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    />
                                ) : (
                                    <FaUserCircle
                                        className={styles.profileIcon}
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    />
                                )}
                                {isDropdownOpen && (
                                    <div className={styles.dropdown}>
                                        <div
                                            className={styles.dropdownItem}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                navigate('/profile');
                                                setIsDropdownOpen(false);
                                            }}
                                        >
                                            Profile
                                        </div>

                                        {/* <div
                      className={styles.dropdownItem}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        navigate('/profile/appliedjobs'); 
                        setIsDropdownOpen(false);
                      }}
                    >
                      Applied Jobs
                    </div> */}

                                        <div
                                            className={styles.dropdownItem}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                navigate('/profile/savedjobs');
                                                setIsDropdownOpen(false);
                                            }}
                                        >
                                            Saved Jobs
                                        </div>
                                        {/* <div
                      className={styles.dropdownItem}


                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toast.success("Logged out successfully!");
                        authCtx.logout();
                        setIsDropdownOpen(false);
                      }}
                    >
                      Logout
                    </div> */}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Mobile Menu */}
                    <div className={styles.navOptionsContainerCollapsible}>
                        {authCtx?.isLoggedIn === false ? (
                            // 5. Mobile Button: Dynamic Link/Text use kiya
                            <Link to={buttonLink} className={styles.animatedButton}>
                                <FaArrowRightLong className={styles.arr2} />
                                <span className={styles.text}>{buttonText}</span>
                                <span className={styles.circle}></span>
                                <FaArrowRightLong className={styles.arr1} />
                            </Link>
                        ) : (
                            <div className={styles.profileContainer} ref={dropdownRef}>
                                {authCtx.profilePic ? (
                                    <img
                                        src={authCtx.profilePic}
                                        alt="Profile"
                                        className={styles.profileImage}
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    />
                                ) : (
                                    <FaUserCircle
                                        className={styles.profileIcon}
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    />
                                )}
                                {isDropdownOpen && (
                                    <div className={styles.dropdown}>
                                        <div
                                            className={styles.dropdownItem}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/profile');
                                                setTimeout(() => setIsDropdownOpen(false), 0);
                                            }}
                                        >
                                            Profile
                                        </div>
                                        {/* <div
                      className={styles.dropdownItem}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/profile/appliedjobs');
                        setTimeout(() => setIsDropdownOpen(false), 0);
                      }}
                    >
                      Applied Jobs
                    </div> */}
                                        <div
                                            className={styles.dropdownItem}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/profile/savedjobs');
                                                setTimeout(() => setIsDropdownOpen(false), 0);
                                            }}
                                        >
                                            Saved Jobs
                                        </div>
                                        {/* <div
                      className={styles.dropdownItem}
                      onClick={(e) => {
                        e.stopPropagation();
                        toast.success("Logged out successfully!");
                        authCtx.logout();
                        setTimeout(() => setIsDropdownOpen(false), 0);
                      }}
                    >
                      Logout
                    </div> */}
                                    </div>
                                )}
                            </div>
                        )}
                        <FaBars
                            className={styles.burgerMenu}
                            onClick={() => mobileNavVisibleHandler(true)}
                        />
                    </div>
                </div>
            </header>
            {isVisibleMobile && (
                <MobileNavOptions
                    isVisible={isVisibleMobile}
                    mobileNavVisibleHandler={mobileNavVisibleHandler}
                />
            )}
        </>
    );
};

export default Navbar;
